// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage, ref } from "firebase/storage";
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB-CXKv-RTaTdSyja_7RIEutua3XMisuTk",
  authDomain: "first-react-portfolio.firebaseapp.com",
  projectId: "first-react-portfolio",
  storageBucket: "first-react-portfolio.appspot.com",
  messagingSenderId: "785515290225",
  appId: "1:785515290225:web:9fdb7df1e2e0e2afd245d0"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const storageRef = ref(storage);
export const imgRef = ref(storage, "about/profileIMG")
export const infoRef = ref(storage, "about/info")
export const featuredImgRef = ref(storage, "featured")
//export const imgRef = ref(storage, "about/aboutImg.png")
